var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('lecture-category-select', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form._category,
      callback: function ($$v) {
        _vm.$set(_vm.form, "_category", $$v);
      },
      expression: "form._category"
    }
  }, 'lecture-category-select', Object.assign({}, _vm.attrs_input, {
    categories: _vm.categories
  }), false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }